import { Directive } from '@angular/core';

@Directive({
  selector: '[app-modal-footer]',
  host: { class: 'relative flex px-5 py-3 bg-white z-80 rounded-b-3xl shadow-up shadow-black/10' },
})
export class ModalFooterDirective {}
